
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.578 8.415c.22 0 .387-.07.519-.202l3.419-3.445a.726.726 0 00.228-.537.76.76 0 00-.228-.536L8.096.224a.676.676 0 00-.518-.22c-.395 0-.703.325-.703.738a.8.8 0 00.193.51l2.145 2.092a7.817 7.817 0 00-1.354-.115 7.337 7.337 0 00-7.374 7.366 7.367 7.367 0 007.383 7.391 7.365 7.365 0 007.374-7.391.72.72 0 00-.747-.747c-.422 0-.703.316-.703.747a5.914 5.914 0 01-5.924 5.941 5.915 5.915 0 01-5.932-5.941 5.895 5.895 0 015.923-5.933c.607 0 1.152.044 1.635.14l-2.417 2.4a.707.707 0 00-.202.492c0 .413.308.721.703.721z","fill":"#000"}})])
          )
        }
      }
    